import React from 'react'

export default React.createClass({
render: function(){
  let tracingSection = []
  if(this.props.address.hasLawnTracing || this.props.address.hasPavementTracing) {
    if (this.props.address.hasLawnTracing) {
      let formattedLawnSize = this.props.address.lawnSize.toString().replace(/(\d)(?=(\d{3})+$)/, '$1,')
      tracingSection.push(<div key='lawn'>
                            <img className='img-responsive center-block' alt='Lawn trace' src={this.props.address.lawnTracingUrl} key={tracingSection.length}/>
                            <p className={'text-center pull-down-xs-1'} key='lawnSize'>Your lawn is {formattedLawnSize} sq. feet</p>
                          </div>)
    }
    if (this.props.address.hasPavementTracing) {
      let formattedPavementSize = this.props.address.pavementSize.toString().replace(/(\d)(?=(\d{3})+$)/, '$1,')
      tracingSection.push(<div key='pavement'>
                            <img className='img-responsive center-block pull-down-xs-2' alt='Pavement trace' src={this.props.address.pavementTracingUrl} key={tracingSection.length} />
                            <p className={'text-center pull-down-xs-1'} key='pavementSize'>Your pavement is {formattedPavementSize} sq. feet</p>
                          </div>)
    }

  }

  return (
    <div>
        <p className='text-center'>{this.props.address.googleAddress}</p>
        {tracingSection}
    </div>
  )
}
})



// WEBPACK FOOTER //
// ./src/components/account/address-listing.jsx